var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabinetMaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000096053821865724986510000000271543788860003731_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 31.86,
    className: "st0",
    width: 19.61,
    height: 17.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.8,50H15.2c-0.27,0-0.49-0.22-0.49-0.49V31.86c0-0.27,0.22-0.49,0.49-0.49H34.8 c0.27,0,0.49,0.22,0.49,0.49v17.65C35.29,49.78,35.07,50,34.8,50z M15.69,49.02h18.63V32.35H15.69V49.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000123429588986510748200000006865883012432671146_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 26.96,
    className: "st0",
    width: 12.74,
    height: 8.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,36.27H2.45c-0.27,0-0.49-0.22-0.49-0.49v-8.82c0-0.27,0.22-0.49,0.49-0.49H15.2 c0.27,0,0.49,0.22,0.49,0.49v8.82C15.69,36.06,15.47,36.27,15.2,36.27z M2.94,35.29h11.76v-7.84H2.94V35.29z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000008135473740539771420000004863469671049293453_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.45,
    y: 35.78,
    className: "st1",
    width: 12.74,
    height: 13.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,50H2.45c-0.27,0-0.49-0.22-0.49-0.49V35.78c0-0.27,0.22-0.49,0.49-0.49H15.2 c0.27,0,0.49,0.22,0.49,0.49v13.73C15.69,49.78,15.47,50,15.2,50z M2.94,49.02h11.76V36.27H2.94V49.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000135682020011689596810000015645612052764142241_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.82,
    y: 26.96,
    className: "st0",
    width: 12.75,
    height: 8.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.57,36.27H33.82c-0.27,0-0.49-0.22-0.49-0.49v-8.82c0-0.27,0.22-0.49,0.49-0.49h12.75 c0.27,0,0.49,0.22,0.49,0.49v8.82C47.06,36.06,46.84,36.27,46.57,36.27z M34.31,35.29h11.76v-7.84H34.31V35.29z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000120520859844902349440000002890934769019894150_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.82,
    y: 35.78,
    className: "st1",
    width: 12.75,
    height: 13.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.57,50H33.82c-0.27,0-0.49-0.22-0.49-0.49V35.78c0-0.27,0.22-0.49,0.49-0.49h12.75 c0.27,0,0.49,0.22,0.49,0.49v13.73C47.06,49.78,46.84,50,46.57,50z M34.31,49.02h11.76V36.27H34.31V49.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000069371446997454572770000011606692419886249916_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.12,42.16c-0.27,0-0.49-0.22-0.49-0.49v-1.96c0-0.27,0.22-0.49,0.49-0.49s0.49,0.22,0.49,0.49v1.96 C19.61,41.94,19.39,42.16,19.12,42.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000042007500114716045370000004798931080018729655_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.67,31.37h-1.96c-0.27,0-0.49-0.22-0.49-0.49s0.22-0.49,0.49-0.49h1.96c0.27,0,0.49,0.22,0.49,0.49 S41.94,31.37,41.67,31.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000107582149797585764030000017607573819943781030_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.31,31.37H7.35c-0.27,0-0.49-0.22-0.49-0.49s0.22-0.49,0.49-0.49h1.96c0.27,0,0.49,0.22,0.49,0.49 S9.58,31.37,9.31,31.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000003821867688015772240000010142021398517344671_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 27.94,
    className: "st0",
    width: 18.63,
    height: 3.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.82,32.35H15.2c-0.27,0-0.49-0.22-0.49-0.49v-3.92c0-0.27,0.22-0.49,0.49-0.49h18.63 c0.27,0,0.49,0.22,0.49,0.49v3.92C34.31,32.13,34.09,32.35,33.82,32.35z M15.69,31.37h17.65v-2.94H15.69V31.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067942123052428831380000018434001163524346781_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.49,
    y: 25,
    className: "st1",
    width: 49.02,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.51,28.43H0.49C0.22,28.43,0,28.21,0,27.94V25c0-0.27,0.22-0.49,0.49-0.49h49.02 c0.27,0,0.49,0.22,0.49,0.49v2.94C50,28.21,49.78,28.43,49.51,28.43z M0.98,27.45h48.04v-1.96H0.98V27.45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000102520776222036220510000011366259297748896172_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.11,30.39h-1.66c-0.27,0-0.49-0.22-0.49-0.49s0.22-0.49,0.49-0.49h1.66c0.27,0,0.49,0.22,0.49,0.49 S19.38,30.39,19.11,30.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000159464172947900292920000012383261963887380361_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.26,30.39H21.6c-0.27,0-0.49-0.22-0.49-0.49s0.22-0.49,0.49-0.49h1.66c0.27,0,0.49,0.22,0.49,0.49 S23.54,30.39,23.26,30.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000144303722363531104880000001874985944492279202_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.42,30.39h-1.66c-0.27,0-0.49-0.22-0.49-0.49s0.22-0.49,0.49-0.49h1.66c0.27,0,0.49,0.22,0.49,0.49 S27.69,30.39,27.42,30.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000015349680513164523640000005362026725759083692_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.57,30.39h-1.66c-0.27,0-0.49-0.22-0.49-0.49s0.22-0.49,0.49-0.49h1.66c0.27,0,0.49,0.22,0.49,0.49 S31.84,30.39,31.57,30.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000149350569645049426900000007200590642058003115_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.75,44.12c-0.27,0-0.49-0.22-0.49-0.49v-1.96c0-0.27,0.22-0.49,0.49-0.49s0.49,0.22,0.49,0.49v1.96 C38.24,43.9,38.02,44.12,37.75,44.12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000044890986418984543080000000823783889472985259_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.27,44.12c-0.27,0-0.49-0.22-0.49-0.49v-1.96c0-0.27,0.22-0.49,0.49-0.49c0.27,0,0.49,0.22,0.49,0.49 v1.96C11.76,43.9,11.55,44.12,11.27,44.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000062894019418760009850000005745421607905221537_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.06,
    y: 0.49,
    className: "st0",
    width: 4.9,
    height: 7.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.96,8.82h-4.9c-0.27,0-0.49-0.22-0.49-0.49V0.49c0-0.27,0.22-0.49,0.49-0.49h4.9 c0.27,0,0.49,0.22,0.49,0.49v7.84C27.45,8.6,27.23,8.82,26.96,8.82z M22.55,7.84h3.92V0.98h-3.92V7.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000094577004376941191550000006837362616372128945_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.59,14.22 26.99,8.33 22.07,8.33 14.48,14.22  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.59,14.71H14.48c-0.21,0-0.4-0.13-0.46-0.33c-0.07-0.2,0-0.42,0.16-0.55l7.6-5.88 c0.09-0.07,0.19-0.1,0.3-0.1h4.92c0.11,0,0.21,0.04,0.3,0.1l7.6,5.88c0.17,0.13,0.23,0.35,0.16,0.55 C34.99,14.57,34.8,14.71,34.59,14.71z M15.91,13.73h17.25l-6.33-4.9h-4.59L15.91,13.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000167398216014372764600000013909169874946259099_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.43,
    y: 14.22,
    className: "st0",
    width: 20.16,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.59,17.65H14.43c-0.27,0-0.49-0.22-0.49-0.49v-2.94c0-0.27,0.22-0.49,0.49-0.49h20.16 c0.27,0,0.49,0.22,0.49,0.49v2.94C35.08,17.43,34.86,17.65,34.59,17.65z M14.92,16.67H34.1v-1.96H14.92V16.67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000006688295000146022550000003943515371340968368_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 0.49,
    className: "st1",
    width: 10.78,
    height: 14.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.53,15.69H37.75c-0.27,0-0.49-0.22-0.49-0.49V0.49c0-0.27,0.22-0.49,0.49-0.49h10.78 c0.27,0,0.49,0.22,0.49,0.49V15.2C49.02,15.47,48.8,15.69,48.53,15.69z M38.24,14.71h9.8V0.98h-9.8V14.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067207296257860821080000008909786788332049053_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.49,
    y: 0.49,
    className: "st1",
    width: 10.78,
    height: 14.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.27,15.69H0.49C0.22,15.69,0,15.47,0,15.2V0.49C0,0.22,0.22,0,0.49,0h10.78c0.27,0,0.49,0.22,0.49,0.49 V15.2C11.76,15.47,11.55,15.69,11.27,15.69z M0.98,14.71h9.8V0.98h-9.8V14.71z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000012455717171085071090000005474647816396351930_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.67,9.8c-0.27,0-0.49-0.22-0.49-0.49V7.35c0-0.27,0.22-0.49,0.49-0.49c0.27,0,0.49,0.22,0.49,0.49v1.96 C42.16,9.58,41.94,9.8,41.67,9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000170239662749572827470000017486115698692372641_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.35,9.8c-0.27,0-0.49-0.22-0.49-0.49V7.35c0-0.27,0.22-0.49,0.49-0.49c0.27,0,0.49,0.22,0.49,0.49v1.96 C7.84,9.58,7.62,9.8,7.35,9.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinetMaking);
export default __webpack_public_path__ + "static/media/cabinet-making.e353e233552da4a1dbc5303ecc60ef6d.svg";
export { ForwardRef as ReactComponent };